import LoaderSimples from 'shared/components/common/LoaderSimples';
import gerarTabelaErros from './gerar-tabela-erros-boletos';
import { aplicarLayoutBoletos } from './layout-boletos';

export const abrirBoletos = ({ payload, ...config }) => {
  if (payload.tipo_retorno === 'html') {
    abrirBoletosHTML({ payload, ...config });
  } else {
    abrirBoletosPDF({ payload, ...config });
  }
};

export const abrirBoletosHTML = ({
  payload,
  endPointObterBoleto,
  setPending,
  setMessage,
  ...params
}) => {
  setPending(true);

  let novaAba;
  if (params.boleto_propria_tela) {
    novaAba = window;
  } else {
    novaAba = window.open('', '_blank');
    novaAba.document.open();
    novaAba.document.write(LoaderSimples('Carregando Boleto...<br>Favor Aguardar'));
    novaAba.document.close();
  }

  const configEndPoint = params.configEndPoint ? params.configEndPoint : {};

  endPointObterBoleto(payload, configEndPoint)
    .then(res => {
      const retorno = (typeof res.data === 'string' ? { html: res.data, erros: [] } : res.data) || {
        html: '',
        erros: []
      };
      const html = retorno.html || '';
      const quantidadeErros = Array.isArray(retorno.erros) ? retorno.erros.length : 0;
      const quantidadeTitulos = Array.isArray(payload.titulos) ? payload.titulos.length : 0;
      const quantidadeSucessos = Math.max(quantidadeTitulos - quantidadeErros, 0);
      const tabelaErros = quantidadeErros ? gerarTabelaErros(retorno.erros) : '';

      novaAba.document.open();
      novaAba.document.write(aplicarLayoutBoletos(html, tabelaErros, quantidadeSucessos));
      novaAba.document.close();

      if (html.trim()) {
        const imagens = Array.from(novaAba.document.images);
        const imagensCarregadas = imagens.map(imagem => {
          if (imagem.complete) {
            return Promise.resolve();
          }

          return new Promise(resolve => {
            imagem.addEventListener('load', resolve, { once: true });
            imagem.addEventListener('error', resolve, { once: true });
          });
        });

        Promise.all(imagensCarregadas).then(() => {
          novaAba.requestAnimationFrame(() => {
            setTimeout(() => {
              novaAba.focus();
              novaAba.print();
            }, 500);
          });
        });
      }
    })
    .catch(() => {
      setMessage('Houve um erro ao tentar obter o boleto. Por favor, tente novamente mais tarde.');
      if (!params.boleto_propria_tela) {
        novaAba.document.write(
          'Houve um erro ao tentar obter o boleto. Por favor, tente novamente mais tarde.'
        );
      }
    })
    .finally(() => {
      setPending(false);
    });
};

export const abrirBoletosPDF = ({ payload, endPointObterBoleto, setPending, setMessage, ...params }) => {
  setPending(true);

  let novaAba;
  if (params.boleto_propria_tela) {
    novaAba = window;
  } else {
    novaAba = window.open('', '_blank');
    novaAba.document.open();
    novaAba.document.write(LoaderSimples('Carregando Boleto...<br>Favor Aguardar'));
    novaAba.document.close();
  }

  const configEndPoint = params.configEndPoint ? params.configEndPoint : {};
  configEndPoint.responseType = 'blob';

  endPointObterBoleto(payload, configEndPoint)
    .then(res => {
      const blob = new Blob([res.data], {
        type: 'application/pdf'
      });

      const url = window.URL.createObjectURL(blob);

      novaAba.location.href = url;

      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 10000);
    })
    .catch(() => {
      setMessage('Houve um erro ao tentar obter o boleto. Por favor, tente novamente mais tarde.');
      if (!params.boleto_propria_tela) {
        novaAba.document.write(
          'Houve um erro ao tentar obter o boleto. Por favor, tente novamente mais tarde.'
        );
      }
    })
    .finally(() => {
      setPending(false);
    });
};
